<template>
    <div class="py-4 container-fluid">
        <transition name="banner-slide">
            <div v-if="isSyncing || progress === 100">
                <RvoSyncBanner />
            </div>
        </transition>
        <div class="row">
            <div class="col-lg-12">
                <div class="row mt-4">
                    <div class="multisteps-form mb-9">
                        <div class="col-12 col-lg-10 m-auto">
                            <div class="card">
                                <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                                    <div class="bg-gradient-success shadow-success border-radius-lg pt-4 pb-3">
                                        <div class="multisteps-form__progress">
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('missing.Missing_from_UBN')" :class="activeStep >= 0 ? activeClass : ''"
                                                @click="activeStep = 0">
                                                <span>{{ $t('missing.Missing_from_UBN') }}</span>
                                            </button> 
                                            <button class="multisteps-form__progress-btn" type="button"
                                                :title="$t('missing.Animal')" :class="activeStep >= 1 ? activeClass : ''"
                                                @click="activeStep = 1">
                                                <span>{{ $t('missing.Animal') }}</span>
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('missing.Date_of_missing')"
                                                :class="activeStep >= 2 ? activeClass : ''" @click="activeStep = 2">
                                                {{ $t('missing.Date_of_missing') }}
                                            </button>
                                            <button class="multisteps-form__progress-btn" type="button" :title="$t('missing.Missing_reason')"
                                                :class="activeStep >= 3 ? activeClass : ''" @click="activeStep = 3">
                                                {{ $t('missing.Missing_reason') }}
                                            </button>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body">
                                    <form class="multisteps-form__form" @submit.prevent="submitForm">
                                        <ubn-info 
                                            v-if="activeStep === 0" 
                                            :class="activeStep === 0 ? activeClass : ''"
                                            :formData="formData" 
                                            :nextStep="nextStep"                                            
                                            :ubns="formData.ubns"                                            
                                            @request-animals="handleAnimalRequest"
                                            @update:formData="updateFormData"
                                        />
                                        <animal-info 
                                            v-if="activeStep === 1" 
                                            :class="activeStep === 1 ? activeClass : ''"
                                            :formData="formData" 
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"
                                            :animals="formData.animals"
                                            @update:formData="updateFormData"
                                        />
                                        <date-info 
                                            v-if="activeStep === 2" 
                                            :class="activeStep === 2 ? activeClass : ''"                                            
                                            :formData="formData"
                                            :prevStep="prevStep"
                                            :nextStep="nextStep"                                            
                                            @update:formData="updateFormData"
                                        />
                                        <reason-info
                                            v-if="activeStep === 3" 
                                            :class="activeStep === 3 ? activeClass : ''"
                                            :formData="formData" 
                                            :missingreasons="formData.missingreasons" 
                                            ref="destructorInfoRef"                                       
                                            :prevStep="prevStep"
                                            :emitter="emitter"
                                        />
                                        
                                        <div class="button-row d-flex">
                                            <button
                                                v-if="activeStep === 3"
                                                @click="saveForm"
                                                :disabled="isSaving"
                                                :class="[
                                                    'btn mb-0 btn-sm bg-gradient-success ms-auto',
                                                    { 'disabled opacity-75': isSaving }
                                                ]"
                                                type="button"
                                            >
                                                <span v-if="isSaving" class="spinner-border spinner-border-sm me-2"></span>
                                                {{ isSaving ? $t('common.Saving') : $t('common.Save') }}
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>
</template>

<script>
import RvoSyncBanner from "@/components/RvoSyncBanner.vue";
import UbnInfo from "./components/UBN.vue";
import AnimalInfo from "./components/Animal.vue";
import ReasonInfo from "./components/Reason";
import DateInfo from "./components/Date.vue";
import * as Choices from "choices.js";
import { nextTick } from 'vue'
import axios from 'axios'
import mitt from 'mitt';
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'Missing_page',
    data() {
        return {
            emitter: mitt(),
            activeStep: 0,
            activeClass: "js-active position-relative",
            formSteps: 4,
            formData: {
                associationId: '',
                ubnId: '',
                animalIds: '',
                missingReasonId: '',
                departureUbn: '',                
                departureDate: null,

                // RVO/I&R notification
                sendToRvo: true,

                ubns:[],
                missingreasons:[],
                animals:[]
            },
            // Store Choices instance            
            choicesInstanceUBN: null,
            choicesInstanceMissingReason: null,
            choicesInstanceAnimal: null,
            choicesExportCountry: null,
            isSaving: false
        };
    },
    components: {
        UbnInfo,
        AnimalInfo,        
        ReasonInfo,
        DateInfo,
        RvoSyncBanner
    },
    async mounted() 
    {
        try {  
            this.associationId = this.$route.params.id;
            await this.fetchAllUBN();

        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
    },    
    computed: {
        userRoleName() {
            return this.$store.state.user?.roleName;
        },
        ...mapState('rvoSync', ['isSyncing', 'progress', 'cancelSource']),
        ...mapGetters('rvoSync', ['elapsedSeconds'])
    },
    methods: {
        async nextStep() {
            if (this.activeStep < this.formSteps -1) {
                this.activeStep += 1;
                //console.log(this.activeStep);
            } else {
                this.activeStep -= 1;
                //console.log(this.activeStep);
            }   

            if(this.activeStep == 3) {
                await this.fetchAllUBN();
                await this.fetchAllMissingReasons();
            }
        },
        async prevStep() {
            if (this.activeStep > 0) {
                this.activeStep -= 1;
                //console.log(this.activeStep);

                if(this.activeStep == 0) {
                    //await this.fetchAllUBNData();
                    await this.fetchAllUBN();
                }
                
                if(this.activeStep == 1) {
                    //await this.fetchAllAnimals();
                }

                if(this.activeStep == 3) {
                    await this.fetchAllUBN();
                    await this.fetchAllMissingReasons();
                }
            }
        },        
        async fetchAllUBN() 
        {
            try { 
                this.$store.commit('setShowLoading', true);

                const role = this.$store.state.roleName;
                const ubnId = this.$store.state.keeperLocationId;

                const response = await axios.get("Location/getallbyassociationdeath", {
                    params: {
                        associationId: this.associationId
                    }
                });                
                const result = response.data;

                if (result.success && Array.isArray(result.data)) {
                    let avl_ubns = result.data;

                    if (role === 'Keeper' && ubnId) {                        
                        avl_ubns = avl_ubns.filter(l => l.id === ubnId);

                        if (avl_ubns.length) {
                            this.formData.ubnId = avl_ubns[0].id;
                            this.formData.ubn = `${avl_ubns[0].ubn} - ${avl_ubns[0].locationFullAddressDropDown}`;
                        }
                    }

                    this.formData.ubns = avl_ubns;
                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "ubnId",
                        dataList: this.formData.ubns,
                        selectedValue: this.formData.ubnId,
                        instanceKey: "choicesInstanceUBN"
                    });
                } else {    
                    this.$showSuccess('errors.Error_fetching_ubns');
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },        
        async fetchAllMissingReasons()
        {
            this.$store.commit('setShowLoading', true);
            try { 

                const response = await axios.get("reference/getreference", {
                    params: {
                        referenceTypeId: '1f2470eb-def0-462b-ac42-c03f2a01a33c'
                    }
                });
                const result = response.data;                             

                if (result.success && Array.isArray(result.data)) {

                    this.formData.missingreasons = result.data;
                    await nextTick();

                    this.initializeChoicesDropdown({
                        id: "missingReasonId",
                        dataList: this.formData.missingreasons,
                        selectedValue: this.formData.missingReasonId,
                        instanceKey: "choicesInstanceMissingReason"
                    });
                } else {    
                    this.$showSuccess('errors.Error_fetching_missingreasons');
                }   
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },        
        async handleAnimalRequest({ ubnId }) {
            this.formData.associationId = this.$route.params.id;
            this.formData.ubnId = ubnId;

            this.$store.commit('setShowLoading', true);
            try {
                const response = await axios.get("Animal/getalldeparture", {
                    params: {
                        associationId: this.$route.params.id,
                        animalTypeId: '1469f04a-a84e-48a5-b79b-bd69f3a5bd51',
                        ubnId
                    }
                });
                if (response.data.success) {
                    if(response.data.count > 0 && Array.isArray(response.data.data)) {
                        this.formData.animals = response.data.data.sort((a, b) => (b.animalNumber ?? '').localeCompare(a.animalNumber ?? ''));
                        this.nextStep();
                    } else {
                        this.$showSuccess('errors.Success_no_animal_found');
                    }
                } else {
                    this.$showError(this.$t('errors.Error_fetching_animals'));
                }
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },              
        initializeChoicesDropdown({ id, dataList, selectedValue, instanceKey }) {
            const element = document.getElementById(id);
            if (!element || element.tagName !== "SELECT") {
                console.error(`Choices: Invalid or missing select element with ID "${id}".`);
                return;
            }

            // Destroy previous instance if it exists
            if (this[instanceKey]) {
                this[instanceKey].destroy();
            }

            // Initialize new Choices instance
            this[instanceKey] = new Choices(element, {
                searchEnabled: true,
                itemSelectText: '',
                shouldSort: false,
                placeholder: true,
            });

            // Set selected value if it exists in list
            if (selectedValue) {
                const optionExists = dataList.some(item => item.id === selectedValue);
                this[instanceKey].setChoiceByValue(optionExists ? [selectedValue] : '');
            }
        },
        updateFormData(updatedData) {
            //this.formData = { ...this.formData, ...updatedData };
            Object.assign(this.formData, updatedData);
        },        
        async saveForm() {

            if (this.isSaving) return; // prevent double click
            this.isSaving = true;

            try {
                const isValid = await this.$refs.destructorInfoRef?.validateAndSubmit();
                if (!isValid) {
                    this.isSaving = false;
                    return;
                }

                await this.submitForm();

            } catch (e) {
                console.error(e);
            } finally {
                this.isSaving = false;
            }
        },           
        async submitForm() {
            try {

                this.$store.commit("setShowLoading", true);

                const formData = new FormData();
                const ignoredKeys = ["ubns", "missingreasons", "animals"];

                for (const key of Object.keys(this.formData)) {

                    if (ignoredKeys.includes(key))
                        continue;

                    const value = this.formData[key];

                    if (key === "departureDate" && value instanceof Date) {
                        formData.append(key, value.toISOString().split("T")[0]);
                    }
                    else if (value !== null && value !== undefined) {
                        formData.append(key, value);
                    }
                }

                const selectedAnimals = this.formData.animals.filter(a =>
                    this.formData.animalIds.includes(a.id)
                );

                let rvoResult = null;

                /*
                * Send missing registration to RVO only when:
                *
                * 1. "Melden aan RVO" is enabled
                * 2. No departure UBN is supplied
                *
                * If sendToRvo is false:
                * - Do NOT send anything to RVO
                * - Only create the missing registration in VeeBoek
                *
                * If departureUbn is supplied:
                * - Do NOT send anything to RVO
                * - Only create the missing registration in VeeBoek
                */
                const shouldSendToRvo = this.formData.sendToRvo === true && !this.formData.departureUbn?.trim();

                /* RVO synchronization */
                if (shouldSendToRvo) {

                    this.$store.commit("setShowLoading", false);

                    const cancelSource = axios.CancelToken.source();

                    this.$store.commit("rvoSync/START_SYNC", cancelSource);

                    await this.$nextTick();

                    try {

                        if (selectedAnimals.length === 1) {

                            const animal = selectedAnimals[0];

                            const rvoPayloadSingle = {
                                rvoRelationNumber: this.$store.state.keeperRVORelationNumber,
                                animalMissingUbn: this.formData.ubnId,
                                animalNumber: animal.animalNumber,
                                missingDate: this.formData.departureDate
                            };

                            rvoResult = await axios.post("/rvo/syncrvomissingsingle", rvoPayloadSingle, { cancelToken: cancelSource.token });
                        }
                        else {
                            const rvoPayloadMultiple = {
                                rvoRelationNumber: this.$store.state.keeperRVORelationNumber,
                                animalMissingUbn: this.formData.ubnId,
                                missingDate: this.formData.departureDate,
                                animals: selectedAnimals.map(a => ({
                                    animalNumber: a.animalNumber,
                                    dierSoort: a.dierSoort ?? "3"
                                }))
                            };

                            rvoResult = await axios.post("/rvo/syncrvomissingmultiple", rvoPayloadMultiple, { cancelToken: cancelSource.token });
                        }

                        /*
                        * RVO rejected the request.
                        *
                        * Do NOT create the missing registration
                        * in VeeBoek.
                        */
                        if (!rvoResult?.data?.success) {

                            throw new Error(rvoResult?.data?.message || this.$t("errors.RVO_sync_failed"));
                        }
                    }
                    finally {
                        this.$store.commit("rvoSync/STOP_SYNC");
                    }
                }

                /*
                * RVO was either:
                *
                * - successfully synchronized, or
                * - intentionally skipped because sendToRvo is false, or
                * - intentionally skipped because departureUbn is supplied.
                *
                * Now create the VeeBoek missing registration.
                */
                const response = await axios.post(
                    "/missing/create",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );

                const result = response.data;

                if (!result?.success) {
                    throw new Error(result.message || "Form submission failed");
                }

                /*
                * Missing registration successfully created
                */
                this.$showSuccess(this.$t("errors.Success_missing_added_successfully"));

                /*
                * RVO accepted the request but returned a warning.
                * The warning does NOT prevent the missing registration.
                */
                const warningMessage = rvoResult?.data?.warningMessage?.trim();

                if (warningMessage) {
                    this.$showWarning(warningMessage, null, { time: 10000 });
                }

                this.$router.push("/missing");

            }
            catch (e) {

                if (!axios.isCancel(e)) {
                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                }
            }
            finally {
                this.$store.commit("rvoSync/STOP_SYNC");
                this.$store.commit("setShowLoading", false);
            }
        },
        async submitForm1() {

            try {

                this.$store.commit("setShowLoading", true);

                const formData = new FormData();
                const ignoredKeys = ["ubns", "missingreasons", "animals"];

                for (const key of Object.keys(this.formData)) {

                    if (ignoredKeys.includes(key))
                        continue;

                    const value = this.formData[key];

                    if (key === "departureDate" && value instanceof Date) {
                        formData.append(key, value.toISOString().split("T")[0]);
                    }
                    else if (value !== null && value !== undefined) {
                        formData.append(key, value);
                    }
                }

                const selectedAnimals = this.formData.animals.filter(a => this.formData.animalIds.includes(a.id));

                let rvoResult = null;

                // RVO synchronization
                if (!this.formData.departureUbn?.trim()) {

                    this.$store.commit("setShowLoading", false);

                    const cancelSource = axios.CancelToken.source();

                    this.$store.commit("rvoSync/START_SYNC", cancelSource);

                    await this.$nextTick();

                    try {

                        if (selectedAnimals.length === 1) {

                            const animal = selectedAnimals[0];

                            const rvoPayloadSingle = 
                            { 
                                rvoRelationNumber: this.$store.state.keeperRVORelationNumber,
                                animalMissingUbn: this.formData.ubnId,
                                animalNumber: animal.animalNumber,
                                missingDate: this.formData.departureDate
                            };

                            rvoResult = await axios.post(
                                "/rvo/syncrvomissingsingle",
                                rvoPayloadSingle,
                                {
                                    cancelToken: cancelSource.token
                                }
                            );
                        }
                        else {

                            const rvoPayloadMultiple = {
                                rvoRelationNumber: this.$store.state.keeperRVORelationNumber,
                                animalMissingUbn: this.formData.ubnId,
                                missingDate: this.formData.departureDate,

                                animals: selectedAnimals.map(a => ({
                                    animalNumber: a.animalNumber,
                                    dierSoort: a.dierSoort ?? "3"
                                }))
                            };

                            rvoResult = await axios.post(
                                "/rvo/syncrvomissingmultiple",
                                rvoPayloadMultiple,
                                {
                                    cancelToken: cancelSource.token
                                }
                            );
                        }

                        // RVO rejected the request
                        //
                        // C + F + N
                        //
                        // DO NOT call /missing/create
                        if (!rvoResult?.data?.success) {
                            throw new Error(rvoResult?.data?.message || this.$t("errors.RVO_sync_failed"));
                        }

                    }
                    finally {
                        this.$store.commit("rvoSync/STOP_SYNC");
                    }
                }

                // RVO succeeded
                //
                // C + J
                // C + W + N -> V + W + J
                //
                // NOW create the VeeBoek missing registration.
                const response = await axios.post(
                    "/missing/create",
                    formData,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                );

                const result = response.data;

                if (!result?.success) {
                    throw new Error(result.message || "Form submission failed");
                }

                // Missing registration successfully created
                this.$showSuccess(this.$t("errors.Success_missing_added_successfully"));

                // RVO accepted the request but returned a warning.
                // The warning does NOT prevent the missing registration.
                // Show RVO warning only once
                const warningMessage = rvoResult?.warningMessage?.trim();
                if (warningMessage) {
                    this.$showWarning(warningMessage, null, { time: 10000 });
                }

                this.$router.push("/missing");
            }
            catch (e) {

                if (!axios.isCancel(e)) {

                    const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                    this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);
                }
            }
            finally {
                this.$store.commit("rvoSync/STOP_SYNC");
                this.$store.commit("setShowLoading", false);
            }
        }
    }
}
</script>
<style>

.choices[data-type*=select-one]::after {
  display: none !important;
}

.choices__inner {
  border: none !important;
  background-color: transparent !important;
  box-shadow: none !important;
  position: relative;
}

.choices[data-type*=select-one] .choices__inner::before {
  content: "";
  position: absolute;
  right: 12px;
  top: 50%;
  width: 0;
  height: 0;
  pointer-events: none;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  transform: translateY(-50%);
}

/* Hide weird characters or fallback icons */
.choices__inner > *:not(.choices__item) {
  font-family: inherit !important;
  content: none !important;
}


.choices__placeholder {
  color: #999;
  font-style: italic;
}

.choices__list--single {
  padding: 0px !important;
}
</style>